// BFF: ● person_accumulators — bffCrmPersonAccumulators.
export { default } from './Accumulators'
